

















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Breadcrumb extends Vue {
	get routes(): any[] {
		const params = this.$route.params;
		const matched = this.$route.matched.filter(r => !!r.path);
		const paths = matched.map(r => this.replaceAll(r.path, '/', ''));
		const routes = matched.filter((r, i) => {
			const path = this.replaceAll(r.path, '/', '');
			const index = paths.lastIndexOf(path);
			return i === index;
		});
		return routes.map(r => {
			let path = r.path;
			for (const key of Object.keys(params)) {
				path = path.replace(`:${key}`, params[key]);
			}
			const title = r.meta.title;
			document.title = this.$t(title) as string;
			return {
				path: path,
				label: title
			};
		});
	}

	replaceAll(text: string, searchstring: string, newstring: string) {
		return text.split(searchstring).join(newstring);
	}
}
